// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".306dbb0e8ffece9a5ff9ae80580b7df934368b74.chunk.js";
};